import axios from "../../helpers/http";

const INITIAL_STATE = {
  isLoading: false,
  isPinSent: false,
  error: null,
};

const actions = {
  getResetPIN: async ({ commit, dispatch }, { phoneNumber }) => {
    try {
      commit("SET_PASSWORD_RESET_LOADING_STATUS", true);
      const result = await axios.post("password/forget", { phoneNumber });
      const { message } = result.data;
      if (process.env.NODE_ENV !== "production") {
        alert(message);
      }
      commit("SET_GET_PIN_SUCCESS");
    } catch (err) {
      const { error = {} } = err.response?.data;
      dispatch("alert/error", error.message || "Please try again!", {
        root: true,
      });
      commit("SET_PASSWORD_RESET_LOADING_STATUS", false);
    }
  },
  getResetToken: async ({ commit }, { phoneNumber, code }) => {
    try {
      commit("SET_PASSWORD_RESET_LOADING_STATUS", true);
      const results = await axios.post("/password/reset_token", {
        phoneNumber,
        code,
      });
      const { token } = results.data;
      commit("SET_PASSWORD_RESET_LOADING_STATUS", false);
      commit("SET_PIN_SENT_STATUS", false);
      return token;
    } catch (err) {
      commit("SET_PASSWORD_RESET_LOADING_STATUS", false);
      const { error = {} } = err.response?.data;
      throw Error(error.message || "Please try again");
    }
  },
  updatePassword: async ({ commit }, data) => {
    try {
      commit("SET_PASSWORD_RESET_LOADING_STATUS", true);
      const { token, passwordConfirmation, password } = data;
      const results = await axios.put(`/password/update?token=${token}`, {
        password,
        passwordConfirmation,
      });
      commit("SET_PASSWORD_RESET_LOADING_STATUS", false);
      const { message } = results.data;
      return message;
    } catch (err) {
      commit("SET_PASSWORD_RESET_LOADING_STATUS", false);
      const { error = {} } = err.response?.data;
      throw Error(error.message || "Failed, please enter your password again!");
    }
  },
};

const mutations = {
  SET_PASSWORD_RESET_LOADING_STATUS(state, status) {
    state.isLoading = status;
  },
  SET_GET_PIN_SUCCESS(state) {
    state.isLoading = false;
    state.isPinSent = true;
  },
  SET_GET_PIN_FAILED(state, error) {
    state.isLoading = false;
    state.isPinSent = false;
    state.error = error;
  },
  SET_PIN_SENT_STATUS(state, status) {
    state.isPinSent = status;
  },
};

const getters = {
  isLoading: (state) => state.isLoading,
  isPinSent: (state) => state.isPinSent,
  getError: (state) => state.error,
};

export const passwords = {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: INITIAL_STATE,
};
